import { AppContainer } from 'react-hot-loader';
import React from 'react';
import ReactDOM from 'react-dom';

import * as appLifecycleService from '../services/app-lifecycle-service';

const renderApp = (Application, store, history, i18n) => {
  appLifecycleService.appIsLoading();
  const renderFn = ReactDOM.hydrate || ReactDOM.render;
  renderFn(
    <AppContainer>
      <Application store={store} history={history} i18n={i18n} />
    </AppContainer>,
    document.getElementById('root'),
  );
};

export default renderApp;
